import { Close, Redeem } from '@mui/icons-material';
import { Box, Button, IconButton, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { trackClick } from 'utils/analytics';

const STORAGE_KEY = 'ideias_popup_fechado';

/** Data de hoje (YYYY-MM-DD) — guardada ao fechar, para reabrir no dia seguinte. */
const hojeStr = () => new Date().toISOString().slice(0, 10);

/**
 * Popup discreto (canto inferior esquerdo) que convida quem está vendo uma lista
 * a conhecer a feature de Ideias de Presentes. Dismissível (X) e lembra que foi
 * fechado (localStorage). Aparece após alguns segundos.
 */
const IdeiasPresentesPopup = () => {
  const [aberto, setAberto] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      // suprime só se foi fechado HOJE; em outro dia, reaparece
      if (localStorage.getItem(STORAGE_KEY) === hojeStr()) return;
    } catch {
      // ignora storage indisponível
    }

    // Abre quando o usuário rola ~1,5 tela (150vh) e PERMANECE aberto.
    const verificar = () => {
      if (window.scrollY > window.innerHeight * 1.5) {
        setAberto(true);
        window.removeEventListener('scroll', verificar);
      }
    };
    window.addEventListener('scroll', verificar, { passive: true });
    verificar();

    return () => window.removeEventListener('scroll', verificar);
  }, []);

  const fechar = () => {
    setAberto(false);
    try {
      localStorage.setItem(STORAGE_KEY, hojeStr());
    } catch {
      // ignora
    }
  };

  if (!aberto) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        left: { xs: 12, sm: 18 },
        bottom: { xs: 18, sm: 24 },
        zIndex: 1250,
        maxWidth: 300,
        p: 1.5,
        pr: 4.5,
        borderRadius: 3,
        bgcolor: '#fff',
        border: '1px solid rgba(0,0,0,0.08)',
        boxShadow: '0 14px 30px rgba(17,24,39,0.18)',
      }}
    >
      <IconButton
        size="small"
        aria-label="Fechar"
        onClick={fechar}
        sx={{ position: 'absolute', top: 4, right: 4 }}
      >
        <Close fontSize="small" />
      </IconButton>
      <Box display="flex" gap={1.25} alignItems="flex-start">
        <Redeem color="primary" sx={{ mt: 0.25 }} />
        <Box>
          <Typography sx={{ fontWeight: 700, fontSize: '0.92rem', lineHeight: 1.2 }}>
            Quer presentear alguém?
          </Typography>
          <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.25 }}>
            Veja nossas ideias de presentes.
          </Typography>
          <Button
            component={Link}
            to="/presentes"
            size="small"
            variant="contained"
            onClick={() => trackClick('lista_popup_ideias', {})}
            sx={{ mt: 1, textTransform: 'none', borderRadius: 2, fontWeight: 700 }}
          >
            Ver ideias de presentes
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default IdeiasPresentesPopup;
